// extracted by mini-css-extract-plugin
export default {"actionButton":"lonV2Rfv","confirmText":"lDbCZx45","confirmHint":"l68xtxP1","confirmActions":"_d9D8ou2"};